import { MenuItem } from '@/types'

export const navigationConfig: MenuItem[] = [
  {
    id: 'home',
    label: 'navigation.home',
    icon: 'Home',
    path: '/',
  },
  {
    id: 'production',
    label: 'navigation.production',
    icon: 'Workflow',
    path: '/production',
    children: [
      // 暂时隐藏视频生产子菜单
      // {
      //   id: 'video-production',
      //   label: 'navigation.videoProduction',
      //   icon: 'Film',
      //   path: '/production/video',
      // },
      {
        id: 'make-long-video',
        label: 'navigation.makeLongVideo',
        icon: 'Film',
        path: '/production/video/input',
      },
      {
        id: 'canvas-workflow',
        label: 'navigation.canvasWorkflow',
        icon: 'Workflow',
        path: '/production/canvas',
      },
    ],
  },
  // 暂时隐藏Tools菜单
  // {
  //   id: 'tools',
  //   label: 'navigation.tools',
  //   icon: 'Tools',
  //   path: '/tools',
  //   children: [
  //     {
  //       id: 'image-generation',
  //       label: 'navigation.imageGeneration',
  //       icon: 'Image',
  //       path: '/tools/image',
  //     },
  //     {
  //       id: 'video-generation',
  //       label: 'navigation.videoGeneration',
  //       icon: 'Video',
  //       path: '/tools/video',
  //     },
  //   ],
  // },
  {
    id: 'history',
    label: 'navigation.history',
    icon: 'List',
    path: '/history',
    children: [
      {
        id: 'video-tasks',
        label: 'navigation.videoTasks',
        icon: 'List',
        path: '/history/tasks',
      },
    ],
  },
  // 暂时隐藏设置菜单
  // {
  //   id: 'settings',
  //   label: 'navigation.settings',
  //   icon: 'Settings',
  //   path: '/settings',
  //   children: [
  //     {
  //       id: 'billing',
  //       label: 'navigation.billing',
  //       icon: 'CreditCard',
  //       path: '/settings/billing',
  //     },
  //     {
  //       id: 'settings1',
  //       label: 'navigation.loginTest',
  //       icon: 'Settings',
  //       path: '/login',
  //     },
  //   ],
  // },
]

export const accountMenu: MenuItem[] = [
  {
    id: 'logout',
    label: 'Login out',
    icon: 'LogOut',
    path: '/logout',
  },
]